module.exports = __webpack_public_path__ + "static/media/hand-holding-phone.9705e961.svg";